import { Divider, Grid, withStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import collect from 'collect.js';
import { addDays, parseISO, toDate } from 'date-fns';
import BackIcon from 'mdi-material-ui/ArrowLeft';
import { withSnackbar } from 'notistack';
import store from 'store';
import React, { Component } from 'react';
import DayPicker from 'react-day-picker';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import compose from 'recompose/compose';
import { Base, LoadingButton, Progress } from 'components';
import Alert from 'components/Alert';
import SelectedList from './components/SelectedItems';
import TypeSelection from './components/TypeSelection';

const propTypes = {};
const defaultProps = {};
const { select } = store;

const mapStateToProps = ({ schedule, loading: { effects } }) => {
    const { dates, saved, fetching, errors } = schedule;

    return {
        errors,
        dates,
        saved,
        fetching,
        loading: effects.schedule.save,
        fetchingDate: effects.schedule.fetchDays,
        items: select.schedule.all(store.getState()),
    };
};

const mapDispatch = ({ schedule }) => ({
    fetch: (date) => schedule.find(date),
    fetchDays: () => schedule.fetchDays(),
    save: (data) => schedule.save(data),
    reset: () => schedule.reset(),
});

const reduxConnector = connect(mapStateToProps, mapDispatch);

class ScheduleForm extends Component {
    initialState = {
        selectedDate: [],
        selectedMenu: [],
        deletedMenu: [],
        method: 'create',
    };

    state = this.initialState;

    get disabledDates() {
        const { dates, match: { params } } = this.props;
        const { method } = this.state;
        const disabledDates = [];
        dates.forEach((date) => disabledDates.push(toDate(parseISO(date))));

        if (method === 'update') {
            const date = toDate(parseISO(params.date));

            return [{
                before: date,
                after: date,
            }];
        }

        return [
            {
                before: toDate(addDays(new Date(), 1)),
            },
            toDate(new Date()),
            { daysOfWeek: [0] },
            ...disabledDates,
        ];
    }

    get menus() {
        const { selectedMenu } = this.state;

        return collect(selectedMenu)
            .sortBy('category_id')
            .all();
    }

    componentDidMount() {
        const { fetchDays, fetch, match } = this.props;
        const { date } = match.params;

        fetchDays(); // fetch disabled days

        if (date) {
            fetch(date);
            this.setState({
                selectedDate: toDate(parseISO(date)),
                method: 'update',
            });
        }
    }

    componentDidUpdate(prevProps) {
        const {
            saved, reset, history, items, enqueueSnackbar,
        } = this.props;

        if (saved) {
            enqueueSnackbar('Schedule has been saved', { variant: 'success' });
            reset();
            history.push('/schedules');
        }

        if (items && prevProps.items !== items) {
            return this.setState({ selectedMenu: items });
        }

        return null;
    }

    componentWillUnmount() {
        this.setState(this.initialState);
    }

    handleSave = () => {
        const { selectedDate: date, selectedMenu: menus, deletedMenu: deleted } = this.state;
        const { save, match } = this.props;
        const method = match.params.date ? 'PUT' : 'POST';

        save({
            date,
            menus,
            deleted,
            method,
        });
    };

    handleMenuClick = (menu, type) => {
        const { selectedMenu: menus } = this.state;

        if (menus.find((m) => menu.id === m.id)) {
            return;
        }

        menus.push({
            ...menu,
            type,
            meals: ['lunch'],
            recommended: false,
            subscription: false,
        });

        this.setState({ selectedMenu: menus });
    };

    handleDeleteClick = (item, type) => {
        const { selectedMenu, method, deletedMenu } = this.state;
        const { id } = item;

        if (method === 'update') {
            if (type === 'delete') {
                deletedMenu.push(item.id);

                this.setState({ deletedMenu });
            } else {
                this.setState({ deletedMenu: deletedMenu.filter((d) => d !== item.id) });
            }
        } else {
            this.setState({ selectedMenu: selectedMenu.filter((menu) => menu.id !== id) });
        }


        return null;
    };

    handleSubscriptionOrRecommendedClick = (item, type) => {
        const { selectedMenu } = this.state;
        const { id } = item;

        if (type === 'delete') {
            this.setState({ selectedMenu: selectedMenu.filter((menu) => menu.id !== id) });

            return null;
        }

        // find menu
        const findMenu = selectedMenu.find((menu) => menu.id === id);

        // set value
        if (type === 'subscription') {
            findMenu.subscription = !findMenu.subscription;
        }

        // filter existing selected menu to avoid duplication and push the new object
        selectedMenu.filter((menu) => menu.id === id)
            .push(findMenu);

        this.setState({ selectedMenu });

        return null;
    };


    handleDayClick = (day) => {
        const { method } = this.state;

        if (method === 'update') {
            return null;
        }

        this.setState({ selectedDate: day });

        return null;
    };

    handleMealTypeChange = (item, type) => {
        const { selectedMenu } = this.state;
        const { id } = item;

        // find menu
        const findMenu = selectedMenu.find((menu) => menu.id === id);
        const { meals } = findMenu;

        if (meals.includes(type)) {
            findMenu.meals = meals.filter((m) => m !== type);
        } else {
            findMenu.meals = meals.filter((m) => m !== type)
                .concat([type]);
        }

        // filter existing selected menu to avoid duplication and push the new object
        selectedMenu.filter((menu) => menu.id === id)
            .push(findMenu);

        this.setState({ selectedMenu });
    };

    render() {
        const {
            fetching, fetchingDate, classes, loading, theme, errors, history,
        } = this.props;
        const { selectedDate, deletedMenu } = this.state;

        return (
            <Base loading={fetching}>

                <Alert errors={errors} />


                <Box display="flex" justifyContent="space-between" alignItems="center">

                    <IconButton size="medium" onClick={() => history.push('/schedules')}>
                        <BackIcon />
                    </IconButton>

                    <LoadingButton
                        color="secondary"
                        size="large"
                        variant="contained"
                        loading={loading}
                        onClick={this.handleSave}
                    >
                        SAVE
                    </LoadingButton>

                </Box>

                <Grid container className={classes.grid}>
                    <Grid md={4} item>
                        {fetchingDate ? <Progress />
                            : (
                                <DayPicker
                                    selectedDays={selectedDate}
                                    onDayClick={this.handleDayClick}
                                    disabledDays={this.disabledDates}
                                />
                            )}
                    </Grid>
                    <Grid md={8} item>
                        <TypeSelection onRowClick={this.handleMenuClick} />
                    </Grid>
                </Grid>

                <Divider component="hr" style={{ marginBottom: theme.spacing(2) }} />

                <SelectedList
                    items={this.menus}
                    deletedMenu={deletedMenu}
                    onMealTypeChange={this.handleMealTypeChange}
                    onDeleteClick={this.handleDeleteClick}
                    onSubscriptionOrRecommendedClicked={this.handleSubscriptionOrRecommendedClick}
                />
            </Base>
        );
    }
}

ScheduleForm.propTypes = propTypes;
ScheduleForm.defaultProps = defaultProps;

const styles = ({ spacing }) => ({
    root: {},
    grid: {
        margin: spacing(3, 0),
    },
    searchBox: {
        maxHeight: 300,
        overflow: 'hidden',
        overflowY: 'auto',
    },
});


export default compose(
    withStyles(styles, {
        name: 'ScheduleForm',
        withTheme: true,
    }),
    withRouter,
    withSnackbar,
    reduxConnector,
)(ScheduleForm);
